var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadPdfDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9523 28.7064L6.74615 28.5121L6.74527 28.5129L2.79492 24.7897L3.77224 23.8685L6.21236 26.1684L6.17782 12H7.57782L7.57782 26.2357L9.94992 24L10.9478 24.9405L6.9523 28.7064Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 27.7504H1V33.2504L41.5 33.2504V27.7504H40V31.7504H2.5L2.5 27.7504Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7812 1.43899C14.7812 0.593308 15.4743 -0.0922546 16.3293 -0.0922546H27.8107C27.9752 -0.0922546 28.1339 -0.0317779 28.2559 0.077434L27.8107 0.563995C28.2559 0.077434 28.2559 0.0773912 28.2559 0.077434L28.4955 0.292453C28.6497 0.431038 28.8731 0.632038 29.1499 0.88191C29.7035 1.38162 30.471 2.07698 31.3267 2.85961C33.0358 4.42271 35.1053 6.34154 36.5238 7.74469C36.6483 7.86776 36.7182 8.03468 36.7182 8.20873V26.1911C36.7182 27.0368 36.0251 27.7224 35.1701 27.7224H16.3293C15.4743 27.7224 14.7812 27.0368 14.7812 26.1911V1.43899ZM35.3912 8.86498H28.6949C27.8396 8.86498 27.1472 8.17906 27.1472 7.33373V1.22025H16.3293C16.2072 1.22025 16.1082 1.31818 16.1082 1.43899V26.1911C16.1082 26.312 16.2072 26.4099 16.3293 26.4099H35.1701C35.2922 26.4099 35.3912 26.312 35.3912 26.1911V8.86498ZM34.431 7.55248H28.6949C28.5732 7.55248 28.4742 7.4549 28.4742 7.33373V2.04895C29.0018 2.52591 29.6803 3.14143 30.4259 3.8233C31.7078 4.99571 33.1833 6.35999 34.431 7.55248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5328 11V16H25.4076C26.1949 16 26.8321 15.7884 27.2916 15.3422C27.7514 14.8958 27.9687 14.2725 27.9687 13.5C27.9687 12.7275 27.7514 12.1042 27.2916 11.6578C26.8321 11.2116 26.1949 11 25.4076 11H23.5328ZM26.4201 12.3882L26.4212 12.3893C26.6492 12.6344 26.7766 12.9957 26.7766 13.5C26.7766 14.0037 26.6495 14.368 26.4206 14.6183C26.1958 14.8597 25.868 14.9913 25.4076 14.9913H24.6888V12.0087H25.4076C25.8674 12.0087 26.195 12.1422 26.4201 12.3882ZM32.672 14.0079V12.9851H30.577V12.0157H33.25V11H29.421V16H30.577V14.0079H32.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6242 11.4322C21.2814 11.1372 20.8246 11 20.2765 11H18.25V16H19.406V14.2534H20.2765C20.824 14.2534 21.2808 14.1186 21.6236 13.8287C21.975 13.5308 22.1441 13.1236 22.1441 12.6302C22.1441 12.1371 21.9752 11.73 21.6242 11.4322ZM20.1537 13.2447C20.4697 13.2447 20.6672 13.1826 20.7817 13.0917C20.891 13.0006 20.9592 12.858 20.9592 12.6302C20.9592 12.3994 20.8895 12.257 20.7785 12.1672C20.661 12.0722 20.464 12.0087 20.1537 12.0087H19.406V13.2447H20.1537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.25 20.2H18.25V18.8H33.25V20.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.25 24.2H18.25V22.8H27.25V24.2Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfDoc);
export default __webpack_public_path__ + "static/media/download-pdf-doc.06b8a8d3.svg";
export { ForwardRef as ReactComponent };